'use strict';

angular.module('substoreApp.services')
    .service('dialogs', ['$uibModal', function ($uibModal) {
        return {
            /**
             * Show ok/cancel dialog.
             * @param config an object containing:
             *   - templateUrl (string, required)
             *   - data (object, optional, can be accessed as 'data' in the
             *     template)
             *   - onOk (function, optional, get's called after user presses OK
             *     button)
             */
            okcancel: function (config) {
                $uibModal.open({
                    templateUrl: 'templates/modaldialog-okcancel.html',
                    controller: function ($scope, $modalInstance) {
                        $scope.innerTemplateUrl = config.templateUrl;
                        $scope.data = config.data;
                        $scope.ok = function () {
                            $modalInstance.close();
                            if (config.onOk) config.onOk();
                        };
                        $scope.cancel = function () {
                            $modalInstance.close("close");
                        }
                    }
                });
            }
        }
    }]);